import { get } from '../request';
import { APP_CONFIG } from '@/config';
import { EntitlementWithDetails } from '@/@types/entitlement';

export const getEntitlementsV2 = async (): Promise<EntitlementWithDetails[]> =>
  await get<EntitlementWithDetails[]>(`${APP_CONFIG.entitlementApiUrl}/v2/active-entitlements/my`);
